import React from 'react';
import { ChatbotProvider } from '../../context/ChatbotContext';
import Chatbot from './Chatbot';

const ChatbotWrapper: React.FC = () => {
  return (
    <ChatbotProvider>
      <Chatbot />
    </ChatbotProvider>
  );
};

export default ChatbotWrapper;
